// Features type 12 layout styles
.features-type-2 {
  .me-container {
    padding-top: 0;

    @include desktop-lg {
      padding-bottom: $spacing-7xl;
    }
  }
}

.features-type-2--centered {
  text-align: center;
}

.features-type-2__cards {
  display: grid;
  grid-template-columns: 1fr;
  gap: var(--spacing-xl);

  @include above(768px) {
    grid-template-columns: repeat(2, 1fr);
    gap: var(--spacing-4xl);
  }

  @include above(960px) {
    grid-template-columns: repeat(3, 1fr);
  }
}

// Features card type 5 styles
.features-card-type-5 {
  background-color: var(--background-color-brand-primary-lightest);
  padding: var(--spacing-2xl);
  border-radius: var(--radius-size-lg);
  align-self: stretch;
  height: 100%;

  @include above(1024px) {
    padding: var(--spacing-4xl);
  }
}

.features-card-type-5__icon {
  @include desktop {
    margin-bottom: var(--spacing-xl);
  }

  .me-icon {
    min-width: 48px;

    svg {
      path {
        fill: var(--color-brand-primary-main);
      }
    }
  }
}

// SignNow-specific styles
sn-features-type-2 {
  .features-card-type-5 {
    display: grid;
    grid-template-columns: 30px 1fr;
    gap: px-to-rem(10px) var(--spacing-sm);
    align-content: start;
    text-align: left;

    .features-card-type-5__icon {
      // grid-column: 1;
      // grid-row: 1;
      // margin-bottom: 0;
      // align-self: start;
      transform: translateY(px-to-rem(3px));

      .me-icon {
        min-width: unset;
        width: 30px;
        height: 30px;
      }
    }

    // Card title is wrapped in a real <me-heading tag="h3"> for SEO; the heading
    // is the grid item (positioned here) and the inner me-button keeps the
    // visible link styling. Neutralize the global h3 sizing/margin.
    .features-card-type-5__title {
      grid-column: 2;
      grid-row: 1;
      place-self: start start;
      margin: 0;

      h3,
      .me-heading {
        font: inherit;
        margin: 0;
      }
    }

    .features-card-type-5__title-link,
    .features-card-type-5__title-link.me-button {
      grid-column: 2;
      grid-row: 1;
      place-self: start start;
      text-align: left;
      font-size: map-get($font-sizes, xl);
      line-height: map-get($line-heights, lg);
      font-weight: map-get($font-weights, bold);
      color: var(--text-color-primary);

      &::before {
        display: none;
      }

      @include desktop {
        font-size: map-get($font-sizes, 2xl);
        line-height: map-get($line-heights, lg);
      }
    }

    me-text {
      grid-column: 2;
      grid-row: 2;
    }
  }

  .features-card-type-5__title-link.me-button--ghost:hover,
  .features-card-type-5__title-link.me-button--ghost.is-hovered {
    color: var(--color-brand-primary-main);

    &::before {
      display: none;
    }
  }
}
